module.exports = __webpack_public_path__ + "prod/20260929161836/img/map2d.f2386104.jpg";